/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
 
  ADD_EC_FOLLOWUP,
  ADD_EC_FOLLOWUP_SUCCESS,
  ADD_EC_FOLLOWUP_ERROR,

 
  
  LOAD_EC_FOLLOWUP_LIST,
  LOAD_EC_FOLLOWUP_LIST_SUCCESS,
  LOAD_EC_FOLLOWUP_LIST_ERROR,
} from "./constants"

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


export function loadEcFollowupList(id) {
  return {
    type: LOAD_EC_FOLLOWUP_LIST,
    id,
  }
}

export function loadEcFollowupListSuccess(ec_followup_list) {
  return {
    type: LOAD_EC_FOLLOWUP_LIST_SUCCESS,
    ec_followup_list,
  }
}

/**
 * @param {string} error
 */

export function loadEcFollowupListError(error) {
  return {
    type: LOAD_EC_FOLLOWUP_LIST_ERROR,
    error,
  }
}

export function addEcFollowup(ecFollowupData) {
  console.log("record", ecFollowupData)
  return {
    type: ADD_EC_FOLLOWUP,
    ecFollowupData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function addEcFollowupSuccess(ecFollowupData, success) {
  console.log("record", ecFollowupData)
  return {
    type: ADD_EC_FOLLOWUP_SUCCESS,
    ecFollowupData,
    success,
  }
}

/**
 * @param {string} error
 */
export function addEcFollowupError(error) {
  return {
    type: ADD_EC_FOLLOWUP_ERROR,
    error,
  }
}



const actions = {
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  addEcFollowup,
  addEcFollowupError,
  addEcFollowupSuccess,


  loadEcFollowupList,
  loadEcFollowupListSuccess,
  loadEcFollowupListError,

}

export default actions
